import { useQuery } from "react-query";
import { getAllAgencies } from "services/agency.service";

export default function useAgencies(params?: {
  page?: number;
  limit?: number;
  search?: string;
}) {
  return useQuery(["agencies", params], () => getAllAgencies(params), {
    keepPreviousData: true,
  });
}
